import * as React from 'react';
import clsx from 'clsx';

import { FormParserContext } from 'src/contexts/form.context';
import { InputTags } from 'src/components/Inputs';
import { CONFIG } from 'src/config';

import classes from './TagsInput.module.scss';

const SEPARATOR = CONFIG.projectCOSeparator;

export function TagsInput() {
  const { value, onChange, script, isDisabled, error } = React.useContext(FormParserContext);

  const values = value ? value.split(SEPARATOR) : [];

  function handleOnChange(newValues: string[]) {
    onChange(newValues.join(SEPARATOR));
  }

  return (
    <InputTags
      autoFocus={script.autofocus}
      className={clsx(classes.container, { 'with-error': !!error })}
      onChange={handleOnChange}
      placeholder={script.placeholder}
      value={values}
      isDisabled={isDisabled}
      separator={SEPARATOR}
    />
  );
}
